import * as XLSX from "xlsx";
import { toast } from "react-toastify";

function exportExcel(dataSections) {
  if (!dataSections || dataSections.length === 0) {
    toast.error("Data kosong atau tidak ada, export dibatalkan.", {
      autoClose: 3000,
    });
    return;
  }

  const wb = XLSX.utils.book_new();

  // ⬇️ 1 sheetData untuk semua section
  const sheetData = [];

  dataSections.forEach((section, idx) => {
    if (!section.data || section.data.length === 0) return;

    const keys = Object.keys(section.data[0]);
    const header = keys.map(toTitleCase);

    // Baris judul section
    sheetData.push([section.title]);
    // Baris header kolom
    sheetData.push(header);
    // Baris‑baris data
    section.data.forEach((item) => {
      sheetData.push(keys.map((k) => item[k]));
    });

    // Opsional: baris kosong pemisah antar‑section (kecuali terakhir)
    if (idx < dataSections.length - 1) sheetData.push([]);
  });

  const ws = XLSX.utils.aoa_to_sheet(sheetData);
  // Satukan semuanya dalam satu sheet bernama "Sections"
  XLSX.utils.book_append_sheet(wb, ws, "Sections");

  XLSX.writeFile(wb, "ExportSections.xlsx");
}


function toTitleCase(str) {
  return str.replace(/_/g, " ").replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1));
}

export default exportExcel;
